'use strict';

var $ = require('jquery');
var analyticsUtil = require('../../../shared/scripts/modules/utils/analyticsUtil');
var config = require('../../../shared/scripts/modules/utils/globalAnalyticsConfig');

var formStepCompleteName = config.GLOBAL_CONFIG.Forms.Events.FormEvents.FORM_STEP_COMPLETE;
var intGroupJoinName = config.GLOBAL_CONFIG.Journeys.INT_GROUP_JOIN;
var addOnsName = config.GLOBAL_CONFIG.Forms.Events.FormStepTypes.ADD_ONS;

var addOns = [];

function addAnalyticsHandlers() {

    $('#thanks').click(function () {

        analyticsUtil.formPush(formStepCompleteName, intGroupJoinName, 4, addOnsName);

    });

    $('#next').click(function () {

        $(".checkbox").each(function () {
            if($(this).prop('checked') === true) {
                addOns.push( $(this).attr('value') );
            }
        });

        analyticsUtil.formAddOnsPush(formStepCompleteName, intGroupJoinName, 4, addOnsName, addOns);

    });

}

module.exports.addAnalyticsHandlers = addAnalyticsHandlers;


//////////////////
// WEBPACK FOOTER
// ./src/international/scripts/pages/join-plan-addons-analytics.js
// module id = UG47
// module chunks = 6 12